module.exports = __webpack_public_path__ + "img/8S.497eed1e.png";